import { gql } from 'apollo-boost';

import { ValidationErrorFragment, ValidationWarningFragment } from './common';

export const updateCampaigns = gql`
    mutation UpdateCampaigns($input: GdUpdateCampaignsInput!, $login: String!) {
        reqId: getReqId
        updateCampaigns(input: $input) {
            updatedCampaigns {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const findOrCreateExperimentsConditions = gql`
    mutation FindOrCreateExperimentsConditions(
        $input: GdCreateRetargetingConditionForExperimentsInput!
        $login: String!
    ) {
        reqId: getReqId
        findOrCreateExperimentsConditions(input: $input) {
            addedConditions {
                retargetingConditionId
                statisticRetargetingConditionId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const getOrCreateMetrikaGoalsForCampaignByCounter = gql`
    mutation GetOrCreateMetrikaGoalsByCounter($input: GdMetrikaGoalsByCounterInput!) {
        reqId: getReqId
        getOrCreateMetrikaGoalsByCounter(input: $input) {
            goals {
                id
                name
                type
            }
            payForConversionGoals {
                id
                name
                type
            }
            isMetrikaAvailable
        }
    }
`;

export const addCampaigns = gql`
    mutation AddCampaigns($input: GdAddCampaignsInput!, $login: String!) {
        reqId: getReqId
        addCampaigns(input: $input) {
            addedCampaigns {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const deleteBrandLiftForCampaigns = gql`
    mutation DeleteBrandLiftForCampaigns($input: GdCampaignIdsListInput!) {
        reqId: getReqId
        deleteBrandLiftForCampaigns(input: $input) {
            campaignIds
        }
    }
`;
